/* src/app/main/pages/apps/shipping-glossary/shipping-glossary.component.css */
.shipping-glossary .app-img {
  width: 65px;
  height: 65px;
}
.shipping-glossary .back-link {
  color: #E8882D;
  font-family: "D-DIN";
  font-size: 16px;
}
.shipping-glossary .back-link .fa-angle-left {
  font-weight: 600;
}
.apps-form-input {
  background-color: #213654;
  padding: 8px 10px;
  margin-top: 30px;
  margin-bottom: 15px;
  box-shadow: 0px 3px 6px #00000029;
}
.apps-form-input label,
.apps-form-result label {
  margin-right: 10px;
  margin-bottom: 0px;
  font-weight: 600;
}
.apps-form-input .form-control {
  font-size: 15px;
  height: auto;
  border-radius: 0;
  padding: 3px 20px 3px 30px;
  border: none;
  margin-right: 10px;
  font-family: "D-DIN";
  width: 100%;
  display: block;
}
.pos-rel {
  position: relative;
}
.glossary-form {
  width: 100%;
}
.form-control {
  padding-left: 2.375rem;
}
.form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 23px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  top: 0px;
  left: 5px;
}
.btn-search {
  background-color: #DCE8F8;
  border: none;
  color: #212121;
  border-radius: 0px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 14px;
  padding: 4px 20px;
  font-family: "D-DIN-Bold";
  margin-right: 15px;
  margin-left: 10px;
}
.more-link {
  white-space: nowrap;
}
.bg-gray {
  background-color: #F5F5F5;
  box-shadow: 0px 3px 6px #00000029;
}
.bg-blue {
  background-color: #EFF6FF;
  padding: 10px 15px;
  border: 1px solid #dedede;
  border-radius: 8px;
  margin-bottom: 12px;
  margin-right: 12px;
}
.overflow-box {
  max-height: 402px;
  overflow: auto;
}
.overflow-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px #E5E5E5;
  background-color: #6A6A6A;
  border: 1px solid #E5E5E5;
}
.overflow-box::-webkit-scrollbar-track {
  border: 1px solid #E5E5E5;
  padding: 2px 0;
  background-color: #E5E5E5;
}
.overflow-box::-webkit-scrollbar {
  width: 8px;
}
@media (min-device-width: 1600px) {
  .apps-form-input label {
    width: 100% !important;
    font-size: 20px;
  }
  .apps-form-input .form-control {
    font-size: 16px;
  }
  .btn-search {
    font-size: 16px;
  }
}
@media (min-device-width: 1440px) {
  h2 {
    font-size: 46px;
  }
  .back-link {
    font-size: 24px !important;
  }
  .glossary-form {
    width: 77%;
  }
  .bg-gray p {
    font-size: 21px;
  }
  .shipping-glossary .app-img {
    width: 75px;
    height: 75px;
  }
}
@media (device-width: 1280px) {
  .apps-form-input label {
    width: 100% !important;
  }
  .glossary-form {
    width: 80%;
  }
}
@media (device-width: 1024px) {
  .btn-search {
    margin-right: 35px;
  }
  .glossary-form {
    width: 79%;
  }
  .apps-form-input label {
    width: 100% !important;
  }
}
@media (device-width: 768px) {
  .apps-form-input {
    display: flex;
    align-items: center;
  }
  .glossary-form {
    width: 80%;
  }
  .btn-search {
    margin-right: 42px;
  }
}
@media (max-width: 768px) {
  .sm-border-none {
    border-right: none !important;
  }
}
@media (max-width: 767px) {
  .apps-form-input {
    text-align: center;
  }
  .apps-form-input .form-control {
    margin-bottom: 15px;
  }
  .apps-form-input label {
    width: 100% !important;
    text-align: center;
    margin-bottom: 10px;
  }
  .glossary-form {
    width: 100%;
    margin-bottom: 10px;
  }
  .btn-search {
    margin-right: 0px;
    margin-bottom: 15px;
  }
  .card-img-top {
    margin-top: 10px;
  }
  .shipping-glossary .back-link {
    margin-bottom: 5px;
  }
  .apps-form-input {
    padding: 15px 10px;
  }
}
.loader {
  position: absolute;
  background-color: #cccccc6e;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
}
.loader-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: auto;
  text-align: center;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
}
.shippingGlossaryDetails {
  position: relative;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=shipping-glossary.component.css.map */
